
export const TRAINING_MODE_UPN = 'test.mode@datacowboys.org'
